"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkDropdownProvider = exports.LinkButtonDirection = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var LinkDropdown_scss_1 = __importDefault(require("./LinkDropdown.scss"));
var LinkButtonDirection;
(function (LinkButtonDirection) {
    LinkButtonDirection["left"] = "left";
    LinkButtonDirection["default"] = "default";
})(LinkButtonDirection || (exports.LinkButtonDirection = LinkButtonDirection = {}));
var LinkDropdownProvider = function (props) {
    var _a = (0, react_1.useState)(LinkButtonDirection.default), direction = _a[0], setDirection = _a[1];
    var _b = (0, react_1.useState)(false), dropdownOpen = _b[0], setOpen = _b[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (props.direction && props.direction !== direction) {
            setDirection(props.direction);
        }
    }, [props.direction]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
    var handleClickOutside = function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
        }
    };
    var toggle = function () {
        setOpen(!dropdownOpen);
    };
    var handleOptionClick = function (item) {
        item.value();
        setOpen(false);
    };
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)(LinkDropdown_scss_1.default['dropdown']), ref: ref },
        react_1.default.createElement("a", { href: "javascript:void(0)", onClick: function () { return toggle(); }, className: (0, classnames_1.default)(props.className) }, props.label),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(LinkDropdown_scss_1.default['dropdown-content'], LinkDropdown_scss_1.default[direction], dropdownOpen ? LinkDropdown_scss_1.default['show'] : '') }, props.items.map(function (x, i) {
            return (react_1.default.createElement("a", { key: i, href: "javascript:void(0)", onClick: function () { return handleOptionClick(x); } }, x.label));
        }))));
};
exports.LinkDropdownProvider = LinkDropdownProvider;
//# sourceMappingURL=LinkDropdown.js.map